import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=9b992478"
import script from "./NeedHelp.vue?vue&type=script&lang=js"
export * from "./NeedHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports